import React from 'react';

const PrintQuestionNumber = ({ model }) => {
  return (
    <div className='print-question-num'>{model.questionNumber}</div>
  );
};
export default PrintQuestionNumber;
